import React from "react";
import Image from "next/image";

import cx from "@/utils/cx";

interface ErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  image?: string;
}

const Error: React.FC<ErrorProps> = ({
  title,
  description,
  className,
  children,
  image = "/error.png",
  ...rest
}) => {
  return (
    <div
      className={cx(
        "flex-1 w-full h-full flex flex-col justify-center items-center",
        className
      )}
      {...rest}
    >
      {image && (
        <div className="relative w-32 h-32 md:w-40 md:h-40">
          <Image
            fill
            sizes="(max-width: 768px) 128px, 160px"
            className="w-full h-full object-contain"
            src="/error.png"
            alt={title || "Error"}
          />
        </div>
      )}
      {title && (
        <h3 className="text-2xl md:text-3xl font-semibold mt-6 text-center">
          {title}
        </h3>
      )}
      {description && (
        <p className="text-center max-w-[80%] mt-4 text-lg md:text-2xl">
          {description}
        </p>
      )}
      {children}
    </div>
  );
};

export default Error;
